module.exports = __webpack_public_path__ + "static/media/hair (41).ae500228.jpg";